import { keyframes } from 'emotion';
import { makeStyles } from '@surveycake/rc';

const bumpin = keyframes(`
	0% {
		:not(lang(ar)){
			transform: scale(1);
		}
		:lang(ar){
			transform: scaleX(-1);
		}
	}

	15% {
		:not(lang(ar)){
			transform: scale(1.2);
		}
		:lang(ar){
			transform: scaleX(-1.2);
		}
	}

	80% {
		:not(lang(ar)){
			transform: scale(0.9);
		}
		:lang(ar){
			transform: scaleX(-0.9);
		}
	}

	100% {
		:not(lang(ar)){
			transform: scale(1);
		}		
		:lang(ar){
			transform: scaleX(-1);
	}
`);

export const useRatingIconStyles = makeStyles([
  [
    'ratingIcon',
    (theme, [active, last]) => [
	  `
			:lang(ar){
				transform: scaleX(-1);
			}
			display: inline-block;
			position: relative;
			color: ${active ? theme.color.primary.default : theme.survey.control.default};
			height: 100%;
			max-width: 40px;
			max-height: 40px;
			cursor: pointer;
			text-align: center;
			line-height: 1;
			transition: color 0.2s;
		`,
      active &&
		`
			-webkit-text-fill-color: transparent;
			-webkit-background-clip: text;
			background-clip: text;
		`,
      active &&
        last &&
		`	
			animation: ${bumpin} 0.4s linear 1;
		`
    ]
  ]
]);
